// A member's profile photo (Account's Change photo, for Accelerator members: Adam, 2 Oct), through
// the 2 functions that hold the avatars bucket (docs/data-model.md 10.6.3). Nothing here touches
// people.photo_path: only sign-upload sets it, with the secret key.
// - Showing it: sign-file's avatar branch signs the photo for 2 minutes, or answers no_photo, and the
//   initials are drawn instead.
// - Changing it: sign-upload's start gives a 1-off upload link into avatars/<their id>/, the photo goes
//   straight to private storage, then finish sets photo_path and removes the photo it replaces.
// The checks below are sign-upload's own, made first so a photo that can't go is never sent; the
// lines are its own.
import { supabase } from '../lib/supabase.js'
import { callHubFunction } from '../lib/functions.js'

export const PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp']
export const PHOTO_ACCEPT = PHOTO_TYPES.join(',')
export const PHOTO_MAX_BYTES = 2 * 1024 * 1024

// The photo's type from its own, or from its name when the browser gives none
export function photoType(file) {
  if (PHOTO_TYPES.includes(file?.type)) return file.type
  const ext = String(file?.name || '').toLowerCase().split('.').pop()
  return { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp' }[ext] || null
}

// The photo's link for an <img>, or null for initials
export async function signPhoto(personId) {
  try {
    const d = await callHubFunction('sign-file', { kind: 'avatar', person_id: personId })
    return typeof d?.url === 'string' && d.url.startsWith('https://') ? d.url : null
  } catch {
    return null
  }
}

// Change photo: { photo_path } once it's theirs. A refusal throws a HubFunctionError with its line.
export async function uploadPhoto(file, contentType) {
  const start = await callHubFunction('sign-upload', {
    action: 'start', kind: 'avatar', file_name: file.name, content_type: contentType, size_bytes: file.size,
  })
  const { error } = await supabase.storage.from(start.bucket || 'avatars')
    .uploadToSignedUrl(start.path, start.token, file, { contentType })
  if (error) throw error
  return callHubFunction('sign-upload', { action: 'finish', receipt: start.receipt })
}
